export default __webpack_public_path__ + "static/media/640_dummy2016-fashion01-de.52110eb0.png";